import {useEffect} from 'react';
import {Stack, Text, useDevice, useViewport} from '@treatwell/ui';
import {useTranslation} from 'react-i18next';
import {PageContainer} from '../../PageContainer';
import {Form} from './Form';
import {MarketingConsent} from './Form/MarketingConsent';
import {SubmitButton} from './Form/SubmitButton';
import {TermsAndConditions} from './Form/TermsAndConditions';
import {UserDetails} from './Form/UserDetails';
import {trackRegisterPageView} from './tracking';

export const RegisterPage = () => {
  const isMobile = useViewport({device: ['mobile', 'tablet']});
  const {isMobile: isWebMobile} = useDevice();
  const {t} = useTranslation();

  useEffect(() => {
    trackRegisterPageView(isWebMobile);
  }, []);

  return (
    <PageContainer>
      <Stack space="lg">
        <Text type={isMobile ? 'lgHeader' : 'heading2'} as="h1">
          {t('register.title')}
        </Text>
        <Form>
          <UserDetails />
          <MarketingConsent />
          <TermsAndConditions />
          <SubmitButton label={t('register.submit')} />
        </Form>
      </Stack>
    </PageContainer>
  );
};
